<template>
  <form @submit.prevent="submit" :class="errorClass">
    <rp-textinput
      v-model="resource.email"
      placeholder="email"
      :error="emailError"
      isRequired
      @input="touch('email')"/>
    <rp-button :disabled="isInvalid" type="primary">Confirm</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import TextInput from '../../../components/ui/inputs/TextInput'

  export default {
    name: 'LoginForm',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-textinput': TextInput
    },

    computed: {
      ...errorMessages(['email'])
    },

    validations: {
      resource: {
        email: {required, email}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/ForgotPasswordFormEmail.vue